// extracted by mini-css-extract-plugin
export default {"notification-dot-container":"NotificationDot_notification-dot-container__E4yyL","notification-dot":"NotificationDot_notification-dot__rbGGi"};